import { connect } from "react-redux";
import * as termsActions from "./actions";

function mapStateToProps(state) {
  return {
    terms: state.terms,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getBorrowerTerms: () => {
      dispatch(termsActions.get_borrower_terms());
    },

    getLoanstepGeneralTerms: () => {
      dispatch(termsActions.get_loanstep_general_terms());
    },

    getSavelendGeneralTerms: () => {
      dispatch(termsActions.get_savelend_general_terms());
    },

    getLenderTerms: () => {
      dispatch(termsActions.get_lender_terms());
    },

    getPaymentServiceTerms: () => {
      dispatch(termsActions.get_payment_service_terms());
    },

    sendNewBorrowerTerms: (content, version, isUpdating) => {
      dispatch(termsActions.send_borrower_terms(content, version, isUpdating));
    },

    sendNewGeneralTerms: (contents, version, isUpdating) => {
      dispatch(termsActions.send_general_terms(contents, version, isUpdating));
    },

    sendNewLsGeneralTerms: (content, version, isUpdating) => {
      dispatch(
        termsActions.send_ls_general_terms(content, version, isUpdating),
      );
    },

    sendNewLenderTerms: (contents, version, isUpdating) => {
      dispatch(termsActions.send_lender_terms(contents, version, isUpdating));
    },

    sendNewPaymentServiceTerms: (contents, version, isUpdating) => {
      dispatch(
        termsActions.send_payment_service_terms(contents, version, isUpdating),
      );
    },
  };
}

export const termsConnector = connect(mapStateToProps, mapDispatchToProps);
